<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="phone"/>
          Email sender
        </h1>
      </div>
    </div>
    <email-sender-list></email-sender-list>
  </main>

</template>

<script>

import EmailSenderList from "./EmailSenderList";
export default {
  components: {EmailSenderList}
}
</script>